import React, { forwardRef, useEffect, useRef, useState } from "react";
import "./ReportGridBox.scss";

import { useDispatch, useSelector } from "react-redux";

import { RemoveModal } from "src/app/modals/RemoveModal/RemoveModal";
import { GridBox } from "../../../../../generator-data/components/GridBox/GridBox";
import {
  setApplyBoxesContent,
  setReportGridElements,
  setReportHiddenGridElements,
} from "../../../../../../redux";
import {
  getReportSavedBoxes,
  saveReportSavedBoxes,
} from "../../../../utils/reportSavedBoxesStorage";

const TYPES_TO_CONFIRM_BEFORE_DELETION = ["creator", "publication"];

export const ReportGridBox = forwardRef((props, ref) => {
  const { key, id, children, ...rest } = props;

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const type = id.includes("creator-insights")
    ? "creator-insights"
    : id.split("-")[0];

  const reportId = useSelector((state) => state.reportReducer.reportId);

  const contentRef = useRef();

  useEffect(() => {
    if (!ref.current) return;
    contentRef.current = ref?.current?.querySelector(
      ".react-grid-item__content",
    );
  }, [ref]);

  const dispatch = useDispatch();

  const {
    reportReducer: { gridElements, hiddenGridElements, applyBoxesContent },
  } = useSelector((state) => state);

  useEffect(() => {
    if (!applyBoxesContent) return;

    const reportSavedBoxes = getReportSavedBoxes();

    const savedBoxes = reportSavedBoxes[reportId];

    if (!savedBoxes?.length) return;

    const boxContent = savedBoxes?.find((item) => item.id === id);

    if (boxContent && contentRef?.current) {
      const type = id.split("-")[0];

      if (type === "header") {
        if (boxContent.content) {
          updateHeaderTitle(boxContent.content);
        }
      } else {
        contentRef.current.innerHTML = boxContent.content;
      }
    }

    dispatch(setApplyBoxesContent(false));
  }, [applyBoxesContent]);

  const saveBoxContent = () => {
    if (!contentRef?.current) return;

    const reportSavedBoxes = getReportSavedBoxes();
    const savedBoxes = reportSavedBoxes[reportId];

    const type = id.split("-")[0];

    let contentToSave = null;

    if (type === "header") {
      const input = document.querySelector(`#${id} .section-header__text`);
      contentToSave = input?.value || "";
    } else {
      contentToSave = contentRef.current.innerHTML;
    }

    let newSavedBoxes = [];
    const newBoxContent = { id, content: contentToSave };

    if (savedBoxes?.length) {
      const boxContent = savedBoxes?.find((item) => item.id === id);

      if (!boxContent) {
        newSavedBoxes = [...savedBoxes, newBoxContent];
      } else {
        newSavedBoxes = savedBoxes.map((box) => {
          if (box.id === id) {
            return newBoxContent;
          }
          return box;
        });
      }
    } else {
      newSavedBoxes = [newBoxContent];
    }

    saveReportSavedBoxes(reportId, newSavedBoxes);
  };

  const updateHeaderTitle = (newValue) => {
    const newGridElements = gridElements.map((item) => {
      if (item.label === id) {
        return {
          ...item,
          text: newValue,
        };
      }
      return item;
    });

    dispatch(setReportGridElements(newGridElements));
  };

  const handleRemoveClick = () => {
    if (TYPES_TO_CONFIRM_BEFORE_DELETION.includes(type)) {
      setShowConfirmationModal(true);
    } else {
      removeFromLayout();
    }
  };

  const removeFromLayout = () => {
    const newElement = gridElements?.find((item) => item.label === id);
    const newGridElements = gridElements?.filter((item) => item.label !== id);

    dispatch(setReportGridElements(newGridElements));
    dispatch(setReportHiddenGridElements([...hiddenGridElements, newElement]));
  };

  return (
    <GridBox
      key={key}
      ref={ref}
      {...rest}
      saveBoxContent={saveBoxContent}
      removeFromLayout={handleRemoveClick}
    >
      {/* this is the content of components children */}
      <>
        {children[0]}
        {showConfirmationModal && (
          <RemoveModal
            onClose={() => setShowConfirmationModal(false)}
            objectNames={[
              gridElements?.find((item) => item.label === id)?.title ?? "",
            ]}
            removeFunction={() => {
              removeFromLayout();
              setShowConfirmationModal(false);
            }}
          />
        )}
      </>
      {/* This is a drag handle */}
      {children[1]}
    </GridBox>
  );
});
